import { render, staticRenderFns } from "./FlagInfo.vue?vue&type=template&id=4f80cdae&"
import script from "./FlagInfo.vue?vue&type=script&lang=js&"
export * from "./FlagInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlagInfo.vue?vue&type=style&index=0&id=4f80cdae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports